/* ============================================================
   main.ts — the "wiring". It runs once the page loads:
   connects the engine to the UI, and makes every button work.
   ============================================================ */

import "./style.css";
import * as Game from "./game";
import * as UI from "./ui";
import { Sound } from "./sound";

document.addEventListener("DOMContentLoaded", () => {
  // 1) Hook the engine up to the UI through callbacks
  Game.initGame(
    {
      playfield: document.getElementById("playfield")!,
      bins: document.getElementById("bins")!,
      toast: document.getElementById("toast")!,
      streak: document.getElementById("streak-badge")!,
    },
    {
      onHud: UI.updateHud,
      onWrong: UI.showWrong,
      onLevelEnd: UI.showLevelEnd,
      onLevelIntro: UI.showLevelIntro,
    },
  );

  UI.refreshSoundLabel();

  // 2) Helper: begin a fresh run at a chosen level
  function playLevel(index: number): void {
    Sound.ensure(); // audio is only allowed after a user tap — this is one
    UI.showScreen("screen-game");
    Game.startRun(index);
  }

  // 3) Home / menu buttons (use data-action on the buttons)
  document.body.addEventListener("click", (e) => {
    const btn = (e.target as HTMLElement).closest<HTMLElement>("[data-action]");
    if (!btn) return;
    const action = btn.dataset.action;
    if (action === "play") {
      Sound.ensure();
      UI.renderLevels(playLevel);
      UI.showScreen("screen-levels");
    } else if (action === "learn") {
      UI.renderLearn();
      UI.showScreen("screen-learn");
    } else if (action === "leaderboard") {
      UI.renderLeaderboard();
      UI.showScreen("screen-leaderboard");
    } else if (action === "toggle-sound") {
      UI.toggleSound();
    } else if (action === "home") {
      Game.quit();
      UI.showScreen("screen-home");
    }
  });

  // 4) Pause / resume
  const pauseModal = document.getElementById("modal-pause")!;
  document.getElementById("btn-pause")!.addEventListener("click", () => {
    Game.pause();
    pauseModal.hidden = false;
  });
  document.getElementById("btn-resume")!.addEventListener("click", () => {
    pauseModal.hidden = true;
    Game.resume();
  });
  document.getElementById("btn-pause-home")!.addEventListener("click", () => {
    pauseModal.hidden = true;
    UI.saveScore(Game.getScore()); // quitting still counts your points
    Game.quit();
    UI.showScreen("screen-home");
  });

  // Auto-pause if the player switches tabs or minimizes
  document.addEventListener("visibilitychange", () => {
    if (document.hidden && Game.isRunning()) {
      Game.pause();
      pauseModal.hidden = false;
    }
  });

  // 5) Post-game buttons
  document.getElementById("btn-retry")!.addEventListener("click", () => {
    UI.showScreen("screen-game");
    Game.retryLevel();
  });
  document.getElementById("btn-next")!.addEventListener("click", () => {
    UI.showScreen("screen-game");
    Game.nextLevel();
  });
  document.getElementById("btn-stats-home")!.addEventListener("click", () => {
    Game.quit();
    UI.showScreen("screen-home");
  });

  // 6) Run the splash, then go Home
  UI.runSplash(() => UI.showScreen("screen-home"));
});
